
<template>

  <svg viewBox="0 0 68 68" aria-hidden="true">

    <path class="st0" d="m66.1 33.6c-0.1-0.2-3.6-4.6-9.3-9.1-3.3-2.6-6.7-4.7-10.1-6.3-4.3-1.9-8.5-2.9-12.6-2.9s-8.4 1-12.6 2.9c-3.4 1.5-6.8 3.6-10.1 6.3-5.8 4.5-9.3 8.9-9.4 9.1l-0.8 1 0.8 1c0.1 0.2 3.6 4.6 9.3 9.1 3.3 2.6 6.7 4.7 10.1 6.2 4.3 1.9 8.5 2.9 12.6 2.9s8.4-1 12.6-2.9c3.4-1.5 6.8-3.6 10.1-6.2 5.7-4.5 9.1-8.9 9.3-9.1l0.8-1-0.7-1zm-32 16c-8.2 0-14.9-6.7-14.9-14.9s6.7-14.9 14.9-14.9 14.9 6.7 14.9 14.9-6.7 14.9-14.9 14.9z"
        
      fill="currentColor" />

    <path class="st0" d="m34.1 24.8c-1.5 0-2.9 0.3-4.2 0.9 1.1 0.6 1.9 1.8 1.9 3.1 0 1.9-1.6 3.5-3.5 3.5-1.3 0-2.5-0.8-3.1-1.9-0.6 1.3-0.9 2.7-0.9 4.2 0 5.4 4.4 9.9 9.9 9.9s9.9-4.4 9.9-9.9-4.6-9.8-10-9.8z"
      
      fill="currentColor" />

  </svg>

</template>
